import store from '@app/store';
import { TransactionType } from '@superbet-group/web.types';
import { isIdCardVerificationPending } from '@models/user/UserDataService';
import {
    KycFlowStates,
    getInitialKycFlowState,
} from '@shared/userProfile/idCardVerification/idCardVerificationEnterFlowState';
import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
import { getAccountConfig } from '@accountFederation/config/accountConfig';
import { getConfig } from '@superbet-group/web.lib.config';
type KycFlow = Record<KycFlowStates, string>;
interface ModalData {
    hasIdCardIntro?: boolean;
    hasDepositIntro?: boolean;
    isRemainingTimeVisible?: boolean;
    actionType?: TransactionType;
    redirect?: string;
}

export function openRequirements(requirementData: ModalData, overrideIntroModalCode?: string, requirementTitle?: string) {
    if (getAccountConfig().isCanonKycEnabled) {
        return;
    }
    const isMultiStepIdVerificationEnabled = store.getters['ui/multiStepVerification/isMultiStepIdVerification'];
    const user = store.getters['data/authentication/user'];
    const isKycPending = isIdCardVerificationPending(user);
    const idVerificationModalCode = store.getters['ui/multiStepVerification/idVerificationModalCode'];
    const multiStepIdVerificationGroup = store.getters['ui/multiStepVerification/multiStepIdVerificationGroup'];
    const isDefaultIntroChanged = !!overrideIntroModalCode;

    const flowMap: KycFlow = {
        NewVerification: idVerificationModalCode,
        OldVerification: idVerificationModalCode,
        GetIdVerification: modalCodes.getIdVerification,
        Intro: overrideIntroModalCode || modalCodes.paymentIntro,
        GetIdIntro: modalCodes.idCardVerificationIntroGetId,
        Pending: modalCodes.idCardVerificationPendingStatus,
    };
    const flowState = getInitialKycFlowState(
        isMultiStepIdVerificationEnabled,
        user,
        isKycPending,
        isDefaultIntroChanged,
        getAccountConfig().hasGetIdKyc,
    );

    if (getConfig().countrySpecific.user.withdrawal.idCardVerificationCheck.isRequired && user.kycDetails?.status === 'needs_review') {
        store.dispatch(
            'ui/modal/setModal',
            {
                code: modalCodes.idCardVerificationPendingStatus,
                data: requirementData,
                ...(requirementTitle ? { title: requirementTitle } : {}),
                group: multiStepIdVerificationGroup,
            },
        );
    } else {
        store.dispatch(
            'ui/modal/setModal',
            {
                code: flowMap[flowState],
                data: requirementData,
                ...(requirementTitle ? { title: requirementTitle } : {}),
                group: multiStepIdVerificationGroup,
            },
        );
    }
}
